import * as React from "react";

import PrimaryButton, { PrimaryButtonColorProps } from "./PrimaryButton";
import "./PrimaryButtonGreen.scss";

type Props = PrimaryButtonColorProps;

export default class PrimaryButtonGreen extends React.PureComponent<Props> {
  render() {
    return (
      <PrimaryButton
        {...this.props}
        primaryButtonColorClassName="PrimaryButtonGreen"
      />
    );
  }
}
